import Subtitle from '@/components/ui/subtitle'
import Link from 'next/link'

const linkClassName =
  'text-black underline decoration-black underline-offset-2 transition hover:text-black visited:text-black'

const faqData = [
  {
    question: 'What makes Ventura different from other agencies?',
    answer:
      (
        <>
          A lot of it comes down to experience. We&apos;ve been doing this for
          25+ years, launched more than 1,000 sites, and we prefer to stay
          involved after launch through{' '}
          <Link href="/vip-support" className={linkClassName}>
            VIP Support
          </Link>{' '}
          instead of disappearing once the project is done.
        </>
      ),
  },
  {
    question: 'Do you work with businesses outside of Tampa?',
    answer:
      (
        <>
          Yes. We work with businesses across the U.S., and most of that
          happens remotely. Calls, screen shares, email, project management
          tools. It works well. If you want to talk through your project,{' '}
          <Link href="/contact-us" className={linkClassName}>
            contact us
          </Link>
          .
        </>
      ),
  },
  {
    question: 'Do you offer full-service packages?',
    answer:
      (
        <>
          Yes. Some clients hire us for one thing, but a lot of them want one
          team handling web design, SEO,{' '}
          <Link href="/paid-search" className={linkClassName}>
            paid search
          </Link>
          , and ongoing support{' '}
          so everything stays in sync.
        </>
      ),
  },
  {
    question: 'What services do you provide?',
    answer:
      (
        <>
          We handle web design and development, Shopify work, SEO, paid ads,{' '}
          <Link href="/email-marketing" className={linkClassName}>
            email marketing
          </Link>
          , social media advertising, and ongoing support. Some clients use us
          for one area. Others want help across the board.
        </>
      ),
  },
  {
    question: 'What platforms do you specialize in?',
    answer:
      (
        <>
          We work with Shopify, Shopify Plus, BigCommerce, WooCommerce,
          WordPress, and more. We also help with migrations from other
          platforms when needed, and we build custom sites through our{' '}
          <Link href="/web-design" className={linkClassName}>
            web design
          </Link>{' '}
          team when a platform solution isn&apos;t the right fit.
        </>
      ),
  },
  {
    question: 'Do you work with small and midsize brands on Shopify Plus?',
    answer:
      'Yes. We help growing brands decide whether Shopify Plus fits their operations, implement the features and integrations they need, and support the store after launch.',
  },
  {
    question: 'How long does it take to see results?',
    answer:
      (
        <>
          Depends on the channel. Paid search can start driving traffic pretty
          quickly.{' '}
          <Link href="/seo" className={linkClassName}>
            SEO
          </Link>{' '}
          is slower and usually takes a few months to really build. Most of the
          time, the right approach is a mix of both.
        </>
      ),
  },
]

const HomeFAQ = () => {
  return (
    <section>
      <div className="mx-auto max-w-screen-xl px-5 md:px-10">
        <div className="mb-10 lg:mb-14 max-w-3xl">
          <Subtitle subtitle="FAQ" textColor="text-vblue2" gradientTextColor="from-vblue2 via-vblue3 to-vcyan1" />
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 lg:text-4xl">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="divide-y divide-neutral-200">
          {faqData.map((faq) => (
            <div
              key={faq.question}
              className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-8 first:pt-0 last:pb-0 lg:py-10 lg:first:pt-0 lg:last:pb-0"
            >
              <div className="md:col-span-5">
                <h3 className="text-lg font-bold tracking-tight text-neutral-800 lg:text-xl">
                  {faq.question}
                </h3>
              </div>
              <div className="md:col-span-7">
                <p className="text-lg leading-relaxed text-black">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default HomeFAQ
